export default __webpack_public_path__ + "media/icons/icon-activities-green-b8e09cef.svg";